import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";
import { lazy } from "react";

const Hostnames = lazy(() => import("@kaltura/mediaspace-features-hostnames"));

export const render = getDsLayoutComponentRenderer(Hostnames);
